/**
 * @file AddBtn
 */

'use strict';
import Common from '../../Utils/Common';

/**
 * @classname ErrorModal
 * @classdesc ErrorModal
 */
export default class ErrorModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log(`ErrorModal.constructor`);
		if($e.val() === '1') Common.showErrorModal('<p class="text text-danger fwb">入力・設定内容に問題があります。</p><p class="text">エラーが出た箇所については修正をおこなってください。</p>');
	};
}
